import { tx } from "@/i18n/tx";
import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { CalendarOff } from "lucide-react";
import ClosuresEditor from "@/components/ClosuresEditor";

const KEEP = ["name", "address", "canton", "vat_number", "covers_per_day", "logo_data_url", "vat_method", "tdfn_rate_1", "tdfn_rate_2", "fiduciary_email"];

// Profil > Jours d'ouverture : même champ que l'onboarding, le planning et la caisse.
export default function ClosuresCard() {
  const [est, setEst] = useState(null);
  const [v, setV] = useState({ closed_weekdays: [], closures: [] });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/establishment").then(({ data }) => {
      if (!data) return;
      setEst(data);
      setV({ closed_weekdays: data.closed_weekdays || [], closures: data.closures || [] });
    }).catch(() => {});
  }, []);

  if (!est) return null;
  const save = async () => {
    setBusy(true);
    try {
      const body = Object.fromEntries(KEEP.filter((k) => est[k] !== undefined && est[k] !== null).map((k) => [k, est[k]]));
      await api.post("/establishment", { ...body, ...v });
      toast.success(tx("ui_closurescard.k0dc7a6"));
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="card-c space-y-3" data-testid="profile-closures-card">
      <div className="flex items-center gap-2">
        <CalendarOff className="w-5 h-5 text-primary-c" />
        <p className="text-xs uppercase tracking-wider text-text-secondary font-semibold">{tx("ui_closurescard.kcaaee9")}</p>
      </div>
      <ClosuresEditor weekdays={v.closed_weekdays} closures={v.closures} onChange={(x) => setV((p) => ({ ...p, ...x }))} />
      <button onClick={save} disabled={busy} className="btn-primary w-full text-sm" data-testid="profile-closures-save">{busy ? "Enregistrement…" : tx("ui_closurescard.kaed882")}</button>
    </div>
  );
}
